// src/App.tsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { ChartOptions } from "chart.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface Health {
  _id: string;
  project: string;
  status: boolean;
  timestamp: string;
}

type GroupedHealthData = Record<
  string,
  Record<string, { true: number; false: number }>
>;

const App: React.FC = () => {
  const [groupedHealthData, setGroupedHealthData] = useState<GroupedHealthData>(
    {}
  );

  const fetchHealthData = () => {
    axios
      .get<Health[]>(`${process.env.REACT_APP_API_BASE_URL}/health`)
      .then((response) => {
        const data = response.data;

        const groupedData = data.reduce((acc, curr) => {
          const day = new Date(curr.timestamp).toISOString().split("T")[0];
          const project = curr.project;

          if (!acc[project]) {
            acc[project] = {};
          }
          if (!acc[project][day]) {
            acc[project][day] = { true: 0, false: 0 };
          }

          acc[project][day][curr.status.toString() as "true" | "false"] += 1;
          return acc;
        }, {} as GroupedHealthData);

        setGroupedHealthData(groupedData);
      })
      .catch((error) => console.error("Error fetching Health:", error));
  };

  useEffect(() => {
    fetchHealthData();
    const intervalId = setInterval(fetchHealthData, 600000);
    return () => clearInterval(intervalId);
  }, []);

  const generateChartData = (project: string) => {
    const projectData = groupedHealthData[project] || {};
    const dates = Object.keys(projectData);
    const trueCounts = dates.map((date) => projectData[date].true);
    const falseCounts = dates.map((date) => projectData[date].false);

    return {
      labels: dates,
      datasets: [
        {
          label: "Status: 200 OK",
          data: trueCounts,
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          borderColor: "rgba(75, 192, 192, 1)",
          borderWidth: 1,
        },
        {
          label: "Status: 500 Internal Error",
          data: falseCounts,
          backgroundColor: "rgba(255, 99, 132, 0.6)",
          borderColor: "rgba(255, 99, 132, 1)",
          borderWidth: 1,
        },
      ],
    };
  };

  const options: ChartOptions<"bar"> = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return `Entries: ${context.raw}`;
          },
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Entries",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <h1>Health Checks per Project</h1>

      <div style={{ width: "60vw", height: "25vh" }}>
        <h2>Project: ESG</h2>
        <Bar data={generateChartData("ESG")} options={options} />
      </div>

      <div style={{ width: "60vw", height: "25vh", marginTop: "2rem" }}>
        <h2>Project: Timesheets</h2>
        <Bar data={generateChartData("Timesheets")} options={options} />
      </div>
    </div>
  );
};

export default App;
